<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

import Table from '../common/SortedTable.vue'

export default {
    name: 'SamplesComponent',
    
    components: {
        Table
    },

    props: {
        samples: {
            type: Array,
            requiered: true
        },
        selectedItems: {
            type: Array,
            default: () => []
        },
        languageStrings: {
            type: Object,
            default: null
        },
        role: {
            type: Number,
            default: 0
        }
    },

    emits: ['selected-samples', 'show-attachments'],

    computed: {
        headers() {
            let h = [
                {
                    id: '',
                    name: '',
                    sort: false
                },
                {
                    id: 'sample-number',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample001 != null ? this.languageStrings.ui.sample001 : 'Č. vzorku'),
                    sort: true
                },
                {
                    id: 'sampling-date',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample002 != null ? this.languageStrings.ui.sample002 : 'Datum odběru'),
                    sort: true,
                    sortType: 'date'
                },
                {
                    id: 'machine',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample003 != null ? this.languageStrings.ui.sample003 : 'Stroj'),
                    sort: true
                },
                {
                    id: 'description',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample006 != null ? this.languageStrings.ui.sample006 : 'Popis'),
                    sort: true,
                    width: 300 
                }
            ]

            if (this.role > 1 && this.role < 5) {
                h.push(
                {
                    id: 'order-number',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample021 != null ? this.languageStrings.ui.sample021 : 'Č. objednávky'),
                    sort: true
                })
                if (this.role > 2) {
                    h.push(...[
                        {
                            id: 'invoice-number',
                            name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample022 != null ? this.languageStrings.ui.sample022 : 'Č. faktury'),
                            sort: true
                        },
                        {
                            id: 'invoice-date',
                            name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample023 != null ? this.languageStrings.ui.sample023 : 'Datum fakturace'),
                            sort: true
                        }
                    ])
                }
            }

            h.push(...[
                {
                    id: 'receiving-date',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample007 != null ? this.languageStrings.ui.sample007 : 'Datum příjmu'),
                    sort: true,
                    sortType: 'date'
                },
                {
                    id: 'processing-date',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample008 != null ? this.languageStrings.ui.sample008 : 'Datum zkoušky'),
                    sort: true,
                    sortType: 'date'
                },
                {
                    id: 'exchange-date',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample011 != null ? this.languageStrings.ui.sample011 : 'Datum výměny'),
                    sort: true,
                    sortType: 'date'
                },
                {
                    id: 'exchanged',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample012 != null ? this.languageStrings.ui.sample012 : 'Vyměněno'),
                    sort: true
                },
                {
                    id: 'supplemented',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample013 != null ? this.languageStrings.ui.sample013 : 'Doplněno'),
                    sort: true
                },
                {
                    id: 'machine-operating-time',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample004 != null ? this.languageStrings.ui.sample004 : 'Provozní hodiny stroje'),
                    sort: true
                },
                {
                    id: 'oil-operating-time',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample014 != null ? this.languageStrings.ui.sample014 : 'Provozní hodiny oleje'),
                    sort: true
                },
                {
                    id: 'collection-place',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample015 != null ? this.languageStrings.ui.sample015 : 'Odběrné místo'),
                    sort: true
                },
                {
                    id: 'collected',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample016 != null ? this.languageStrings.ui.sample016 : 'Odběr provedl'),
                    sort: true
                },
                {
                    id: 'oil-temperature',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample017 != null ? this.languageStrings.ui.sample017 : 'Teplota oleje'),
                    sort: true
                },
                {
                    id: 'ambient-temperature',
                    name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample018 != null ? this.languageStrings.ui.sample018 : 'Teplota prostředí'),
                    sort: true
                }
            ])

            if (this.role > 1 && this.role < 5) {
                h.push(...[
                    {
                        id: 'date-sent',
                        name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample024 != null ? this.languageStrings.ui.sample024 : 'Datum odeslání'),
                        sort: true,
                        sortType: 'date'
                    },
                    {
                        id: 'sender',
                        name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample025 != null ? this.languageStrings.ui.sample025 : 'Odeslal'),
                        sort: true
                    },
                    {
                        id: 'date-locked',
                        name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample026 != null ? this.languageStrings.ui.sample026 : 'Datum zamknutí'),
                        sort: true,
                        sortType: 'date'
                    },
                    {
                        id: 'locked-by',
                        name: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample027 != null ? this.languageStrings.ui.sample027 : 'Zamknul'),
                        sort: true
                    }
                ])
            }

            return h
        },
        rows() {
            let r = []

            for (let i = 0; i < this.samples.length; i++) {
                r.push({
                    id: this.samples[i].id,
                    selected: (this.selectedItems.findIndex(x => x === this.samples[i].id) !== -1),
                    cells: [
                        {
                            id: '',
                            align: 'center',
                            contenttype: 'html',
                            clickevent: (this.samples[i].attachments != null && this.samples[i].attachments.length > 0),
                            content: (
                                (this.samples[i].analysisConclusion != null 
                                    ? (this.samples[i].analysisConclusion.generalConclusion === 3 
                                        ? '<img src="' + require('@/assets/images/circle-red.svg') + '" height="15px" />' 
                                        : (this.samples[i].analysisConclusion.generalConclusion === 2 
                                            ? '<img src="' + require('@/assets/images/circle-orange.svg') + '" height="15px" />'
                                            : (this.samples[i].analysisConclusion.generalConclusion === 1 
                                                ? '<img src="' + require('@/assets/images/circle-yellow.svg') + '" height="15px" />'
                                                : '<img src="' + require('@/assets/images/circle-green.svg') + '" height="15px" />'))) 
                                    : '<img src="' + require('@/assets/images/circle-grey.svg') + '" height="15px" />')
                                +
                                (this.samples[i].attachments != null && this.samples[i].attachments.length > 0 ? '&nbsp;<img src="' + require('@/assets/images/paperclip.svg') + '" height="15px" style="cursor: pointer;" />' : '')
                                +
                                (this.role > 1 && this.role < 5 && this.samples[i].locked != null && this.samples[i].locked ? '&nbsp;<img src="' + require('@/assets/images/lock.svg') + '" height="15px" />' : '')
                            )
                        },
                        {
                            id: 'sample-number',
                            contenttype: 'text',
                            content: (this.samples[i].sif != null ? this.samples[i].sif : '')
                        },
                        {
                            id: 'sampling-date',
                            contenttype: 'text',
                            content: (this.samples[i].collectionDate != null ? this.formatDate(this.samples[i].collectionDate) : '')
                        },
                        {
                            id: 'machine',
                            contenttype: 'text',
                            content: (this.samples[i].machine != null ? this.samples[i].machine.name : '')
                        },
                        {
                            id: 'description',
                            contenttype: 'text',
                            width: 300,
                            content: (this.samples[i].description != null ? this.samples[i].description : '')
                        }
                    ]
                })

                if (this.role > 1 && this.role < 5) {
                    r[i].cells.push(
                    {
                        id: 'order-number',
                        contenttype: 'text',
                        content: (this.samples[i].order != null && this.samples[i].order.number != null ? this.samples[i].order.number : '')
                    })
                    if (this.role > 2) {
                        r[i].cells.push(...[
                            {
                                id: 'invoice-number',
                                contenttype: 'text',
                                content: (this.samples[i].order != null && this.samples[i].order.invoiceNumber != null ? this.samples[i].order.invoiceNumber : '')
                            },
                            {
                                id: 'invoice-date',
                                contenttype: 'text',
                                content: (this.samples[i].order != null && this.samples[i].order.invoiceDate != null ? this.formatDate(this.samples[i].order.invoiceDate) : '')
                            }
                        ])
                    }
                }

                r[i].cells.push(...[
                    {
                        id: 'receiving-date',
                        contenttype: 'text',
                        content: (this.samples[i].receivingDate != null ? this.formatDate(this.samples[i].receivingDate) : '')
                    },
                    {
                        id: 'processing-date',
                        contenttype: 'text',
                        content: (this.samples[i].processingDate != null ? this.formatDate(this.samples[i].processingDate) : '')
                    },
                    {
                        id: 'exchange-date',
                        contenttype: 'text',
                        content: (this.samples[i].exchangeDate != null ? this.formatDate(this.samples[i].exchangeDate) : '')
                    },
                    {
                        id: 'exchanged',
                        content: (this.samples[i].exchanged != null 
                            ? (this.samples[i].exchanged 
                                ? (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample019 != null ? this.languageStrings.ui.sample019 : 'Ano') 
                                : (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sample020 != null ? this.languageStrings.ui.sample020 : 'Ne'))
                            : '')
                    },
                    {
                        id: 'supplemented',
                        contenttype: 'text',
                        content: (this.samples[i].supplemented != null ? this.samples[i].supplemented : '')
                    },
                    {
                        id: 'machine-operating-time',
                        contenttype: 'text',
                        content: (this.samples[i].machineWorkingHours != null ? this.samples[i].machineWorkingHours : '')
                    },
                    {
                        id: 'oil-operating-time',
                        contenttype: 'text',
                        content: (this.samples[i].oilWorkingHours != null ? this.samples[i].oilWorkingHours : '')
                    },
                    {
                        id: 'collection-place',
                        contenttype: 'text',
                        content: (this.samples[i].collectionPlace != null ? this.samples[i].collectionPlace : '')
                    },
                    {
                        id: 'collected',
                        contenttype: 'text',
                        content: (this.samples[i].collectionPersonName != null ? this.samples[i].collectionPersonName : '')
                    },
                    {
                        id: 'oil-temperature',
                        contenttype: 'text',
                        content: (this.samples[i].oilTemperature != null ? this.samples[i].oilTemperature : '')
                    },
                    {
                        id: 'ambient-temperature',
                        contenttype: 'text',
                        content: (this.samples[i].environmentTemperature != null ? this.samples[i].environmentTemperature : '')
                    }
                ])

                if (this.role > 1 && this.role < 5) {
                    r[i].cells.push(...[
                        {
                            id: 'date-sent',
                            contenttype: 'text',
                            content: (this.samples[i].shippingDate != null ? this.formatDate(this.samples[i].shippingDate) : '')
                        },
                        {
                            id: 'sender',
                            contenttype: 'text',
                            content: (this.samples[i].shippingPerson != null && this.samples[i].shippingPerson.name != null ? this.samples[i].shippingPerson.name : '')
                        },
                        {
                            id: 'date-locked',
                            contenttype: 'text',
                            content: (this.samples[i].lockedDate != null ? this.formatDate(this.samples[i].lockedDate) : '')
                        },
                        {
                            id: 'locked-by',
                            contenttype: 'text',
                            content: (this.samples[i].lockedPerson != null && this.samples[i].lockedPerson.name != null ? this.samples[i].lockedPerson.name : '')
                        }
                    ])
                }
            }

            return r
        }
    },
    
    methods: {
        formatDate(date) {
            return date !== null ? dayjs(date + 'Z').utcOffset(0).format('D.M.YYYY') : ''
        },
        setSelectedSamples(value) {
            this.$emit('selected-samples', value)
        },
        clickEvent(sampleId, cellId) {
            if (cellId === '') {
                this.$emit('show-attachments', sampleId)
            }
        }
    }
}
</script>


<template>
    <Table v-if="samples.length > 0" :headers="headers" :rows="rows" :multiselect="true" @selected-items="setSelectedSamples" @click-event="clickEvent" />
</template>
